import { useRecentServiceState } from '@kc-console/context';

import type { RecentService } from '@kc-console/context';
/** 주석 작성
 * ~~~을 콘솔 레이아웃에 맞게 재정의하여 제공하는 훅입니다.
 * @description
 * -
 */
interface RefinedRecentServiceStateProps {
  recentServices: RecentService[];
}

export const useRefinedRecentServiceState = (): RefinedRecentServiceStateProps => {
  const { data = [] } = useRecentServiceState();

  return {
    recentServices: data,
  };
};
